import { filterByBonusMiles } from '@features/tourProduct/filterTourProducts';
import { type IBackboneProduct } from '@ve/types/backboneModels/Domain/ObjectValue';
import { ProductType } from '@ve/types/ProductType';

export default (tourProduct: IBackboneProduct, filterModel: boolean) => {
    if (!filterModel) return true;

    const product = tourProduct.get('product');
    if (!product) return false;

    const productType = tourProduct.get('type');
    if (productType !== ProductType.TourProduct) {
        return false;
    }

    return filterByBonusMiles(product.attributes);
};
